import { DraggableProvidedDraggableProps } from '@hello-pangea/dnd';
import { CSSProperties } from 'react';

export const getItemStyle = (
	isDragging: boolean,
	draggableStyle: DraggableProvidedDraggableProps['style'],
): CSSProperties => ({
	userSelect: 'none',
	opacity: isDragging ? 0.5 : 1,
	...draggableStyle,
});
